import React,{createContext,useContext,useState,useEffect,useCallback} from 'react'
import {useAuth} from './AuthContext'
import {domusApi} from '../services/domusApi'
import {linkInstallation} from '../services/familyInstallationIdentity'
const FamilyContext=createContext(null)
export const FamilyProvider=({children})=>{
 const {user}=useAuth()
 const [family,setFamily]=useState(null)
 const [familyMembers,setFamilyMembers]=useState([])
 const [loading,setLoading]=useState(false)
 const refreshFamily=useCallback(async()=>{
   if(!user){setFamily(null);setFamilyMembers([]);return}
   setLoading(true)
   try{const r=await domusApi.families();const current=r.data?.[0]||null;setFamily(current);if(current){const m=await domusApi.familyMembers(current.id);setFamilyMembers(m.data||[])}else setFamilyMembers([])}
   catch(e){console.error('Falha ao carregar família',e);setFamily(null)}
   finally{setLoading(false)}
 },[user?.uid])
 useEffect(()=>{refreshFamily()},[refreshFamily])
 // O vínculo local aparece automaticamente depois de sessão e pertença familiar verificadas.
 // Nunca serve como token de autenticação ou autorização no servidor.
 useEffect(()=>{
   if(!user?.id||!family?.id)return
   linkInstallation({userId:user.id,familyId:family.id}).catch(()=>{})
 },[user?.id,family?.id])
 const removeMember=async()=>{throw Error('Gestão de membros ainda não disponível')}
 return <FamilyContext.Provider value={{family,familyMembers,loading,removeMember,setFamily,setFamilyMembers,setLoading,refreshFamily}}>{children}</FamilyContext.Provider>
}
export {FamilyContext}
